import { useMemo } from "react";
import { PROVISIONING_STAGES } from "./props";

export function useIsInitializingPhase(stage) {
  return useMemo(() => {
    return PROVISIONING_STAGES.includes(stage);
  }, [stage]);
}
